var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9561 10.5586C12.1022 9.9855 13.3927 11.0205 13.082 12.2637L12.373 15.0996L12.415 15.0791C12.7854 14.8942 13.2357 15.0447 13.4209 15.415C13.6058 15.7854 13.4553 16.2357 13.085 16.4209L13.0439 16.4414C11.8978 17.0145 10.6073 15.9795 10.918 14.7363L11.627 11.9004L11.585 11.9209C11.2146 12.1058 10.7643 11.9553 10.5791 11.585C10.3942 11.2146 10.5447 10.7643 10.915 10.5791L10.9561 10.5586Z",
    fill: "#0F172A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0078 7.5C12.4219 7.50017 12.7578 7.83589 12.7578 8.25V8.25781C12.7576 8.67178 12.4218 9.00764 12.0078 9.00781H12C11.5859 9.00781 11.2502 8.67188 11.25 8.25781V8.25C11.25 7.83579 11.5858 7.5 12 7.5H12.0078Z",
    fill: "#0F172A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25ZM12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutline);
export default __webpack_public_path__ + "static/media/outline.ac8f9dc8ae2cfb65e82cbc265dce51fd.svg";
export { ForwardRef as ReactComponent };